<template lang="pug">
.footer__item
    ul(:style="ispad? 'padding-right: 11px;' : ''")
        li.footer-item-title
            router-link(:to="data.link") {{ data.title }}
            i.fas.fa-chevron-down
        li.footer-toggle-me
            ul
                li.footer-item-link(v-for="option in data.options")
                    router-link(:to="option.link") {{ option.title }}
</template>
<script>
export default {
    props: ["data", "ispad"]
}
</script>


// WEBPACK FOOTER //
// src/components/atoms/PmFooterOption.vue